export enum State {
	before,
	after
}
export interface OnStateChanges {
	state: State;
	onStateChanges():void;
	allFormState: State;
}
